import { placeholderColor } from 'assets/jss/material-dashboard-pro-react';
const contactDetailsFBBStyle = () => ({
	gridMargin: {
		marginTop:'24px'
	},
	bestTimeSelect:{
		width: '100%',
	},
	bestTimeSelectPlaceholder: {
		color: placeholderColor
	}
});

export default contactDetailsFBBStyle;
